export default __webpack_public_path__ + "static/media/main.ccedcd4c.jpeg";